// NPM
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

// SERVICES
import { fetchCustomerSettingList } from "Services/customer-settings.service";

// STYLE
import "../modal-forms/modal-forms.scss";

// ANT COMPONENTS
import { Col, Row } from "antd";
import { DataTable } from "@life-line-lab/components-react";
import DataTableFilter from "Components/shared/data-table-filter";
import ModuleTitleBar from "Components/shared/module-title-bar/module-title-bar";

interface ApplicableCustomersProps {
  info: any;
}

const ApplicableCustomers: React.FC<ApplicableCustomersProps> = ({ info }) => {
  const { t } = useTranslation();

  const handleSearch = async (text: string) => {
    //TODO function
  };

  const [customers, setCustomers] = useState<any>();

  const fetchApplicableCustomers = async () => {
    const filters = {
      orderSettingID: info._id,
    };

    const responseData = await fetchCustomerSettingList(filters);
    if (responseData) {
      setCustomers(responseData.data);
    }
  };

  useEffect(() => {
    fetchApplicableCustomers();
  }, []);

  const columns = [
    {
      title: t("label.customers"),
      dataIndex: ["org", "orgName"],
    },
    {
      title: t("label.surcharge"),
      dataIndex: "surcharge",
      render: (_: any, record: any) => {
        return (
          <span>
            {record?.customerSetting?.surcharge?.fixedAmount
              ? `RM ${record?.customerSetting?.surcharge?.fixedAmount} ${
                  record?.customerSetting?.surcharge?.percentage
                    ? `OR ${record?.customerSetting?.surcharge?.percentage}%`
                    : ""
                }`
              : `${record?.customerSetting?.surcharge?.percentage}%`}
          </span>
        );
      },
    },
    {
      title: t("label.surchargeType"),
      dataIndex: ["customerSetting", "surchargeType"],
      render: (_: any, record: any) => {
        return (
          <span
            className={
              record?.customerSetting?.surchargeType === "DEFAULT"
                ? "default"
                : record?.customerSetting?.surchargeType === "DISCOUNT"
                ? "discount"
                : record?.customerSetting?.surchargeType === "MARKUP"
                ? "markup"
                : ""
            }
          >
            {record.customerSetting?.surchargeType || ""}
          </span>
        );
      },
    },
    {
      title: t("label.capAmount"),
      dataIndex: ["customerSetting", "surcharge", "capAmount"],
      render: (text: any) => <>{text && `RM ${text}`}</>,
    },
  ];

  return (
    <div className="modal-forms--applicable-customers">
      <ModuleTitleBar
        titleText={t("title.applicableCustomers")}
        haveSubtitle
        subtitleText={info?.name}
      />
      <Row>
        <Col span={12} className="mb-0">
          {t("label.validFrom").toUpperCase() + ": " + info?.validFrom?.format("MM/DD/YYYY")}
        </Col>
        <Col span={12} className="mb-0">
          {t("label.validTo").toUpperCase() + ": " + info?.validTo?.format("MM/DD/YYYY")}
        </Col>
      </Row>
      <DataTable
        columns={columns as any}
        scroll={{ y: 300 }}
        dataSource={customers || []}
        title={() => (
          <DataTableFilter
            searchPlaceholder={t("label.search")}
            onSearch={(text) => {
              handleSearch(text);
            }}
          />
        )}
      />
    </div>
  );
};

export default ApplicableCustomers;
